import { FC } from 'react';
import { WorkspaceEnum } from '@models/Workspace';
import ManufacturersWorkspace from './ManufacturersWorkspace';
import OperatorsWorkspace from './OperatorsWorkspace';
import SalesWorkspace from './SalesWorkspace';

const MANUFACTURERS_SECTIONS = ['news-reports', 'trending-now', 'category-lens', 'places', 'recent-searches'];
const OPERATORS_SECTIONS = ['news-reports', 'trending-now', 'category-lens', 'recent-searches'];
const SALES_SECTIONS = ['news-reports', 'landscape', 'sales-focus-chains', 'category-lens', 'recent-searches'];

export const WORKSPACE_DEFAULT_SECTIONS: Record<WorkspaceEnum, string[]> = {
    [WorkspaceEnum.Manufacturers]: MANUFACTURERS_SECTIONS,
    [WorkspaceEnum.Operators]: OPERATORS_SECTIONS,
    [WorkspaceEnum.Sales]: SALES_SECTIONS,
    [WorkspaceEnum.Pricing]: [],
};

export const WORKSPACE_COMPONENTS: Partial<Record<WorkspaceEnum, FC>> = {
    [WorkspaceEnum.Manufacturers]: ManufacturersWorkspace,
    [WorkspaceEnum.Operators]: OperatorsWorkspace,
    [WorkspaceEnum.Sales]: SalesWorkspace,
};
